import { connect } from 'react-redux';
import MySessions from './MySessions';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(MySessions);
